import { render, staticRenderFns } from "./ActivateAssets.vue?vue&type=template&id=a8d16984"
import script from "./ActivateAssets.vue?vue&type=script&lang=js"
export * from "./ActivateAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports